// import React, { useMemo, useState } from "react";
// import ReactApexChart from "react-apexcharts";
// import ReactDOM from "react-dom";
// import { capitalizedFirstAlphaBet } from "../../../utilities/utilities";

// const PieChart = ({ dashboardData }) => {
//   const makingSeriesAnd = () => {
//     if (!dashboardData?.byOrderStatus?.length) {
//       return [];
//     }

//     const SeriesArr = [];
//     const labelsArr = [];

//     if (dashboardData?.byOrderStatus?.length) {
//       dashboardData?.byOrderStatus?.forEach((element) => {
//         SeriesArr.push(element.count);
//         labelsArr.push(capitalizedFirstAlphaBet(element._id));
//       });
//       labelsArr.push("Scheduled");
//       SeriesArr.push(dashboardData?.totalScheduledOrders || 0);
//       labelsArr.push("Cancelled");
//       SeriesArr.push(dashboardData?.totalCancelledOrders || 0);
//     }

//     return {
//       series: SeriesArr,
//       options: {
//         chart: {
//           width: 380,
//           type: "pie",
//         },
//         labels: labelsArr,
//         colors: ["#1C2E4F", "#FFA84A", "#9B88ED", "#FB67CA"],
//         responsive: [
//           {
//             breakpoint: 480,
//             options: {
//               chart: {
//                 width: 200,
//               },
//               legend: {
//                 position: "bottom",
//               },
//             },
//           },
//         ],
//         tooltip: {
//           y: {
//             formatter: (value) => value,
//             title: {
//               formatter: (seriesName) => seriesName,
//             },
//           },
//         },
//       },
//     };
//   };
//   const charData = useMemo(makingSeriesAnd, [dashboardData?.byOrderStatus]);

//   return (
//     <div>
//       <div id="chart">
//         {charData.series && (
//           <ReactApexChart
//             options={charData.options}
//             series={charData.series}
//             type="pie"
//             className="w-100"
//           />
//         )}
//       </div>
//       <div id="html-dist"></div>
//     </div>
//   );
// };

// export default PieChart;

import React from "react";
import Chart from "react-apexcharts";

const AppointmentStatusPie = () => {
  const chartOptions = {
    chart: {
      type: "pie",
    },
    labels: ["Upcoming", "Completed", "Ongoing", "Cancelled"],
    legend: {
      position: "bottom",
    },
    colors: ["#1A3D6D", "#4CAF50", "#FFC107", "#F44336"], // custom colors
  };

  const chartSeries = [10, 25, 15, 5]; // Example data (counts for each status)

  return (
    <div>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="pie"
        width="380"
      />
    </div>
  );
};

export default AppointmentStatusPie;
